import { render, staticRenderFns } from "./WebsiteReview.vue?vue&type=template&id=bd72f3dc&lang=pug"
import script from "./WebsiteReview.vue?vue&type=script&lang=js"
export * from "./WebsiteReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports